import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ServiceProviderModule } from '../../services';
import { GenericModule } from '../generic';
import { QueuingSystemSharedModule } from '../../shared';

import { ACCOUNT_ROUTES } from './account.route';
import { PasswordStrengthBarComponent } from './password/password-strength-bar.component';
import { PasswordResetInitComponent } from './password/reset/password-reset-init.component';
import { PasswordResetFinishComponent } from './password/reset/password-reset-finish.component';
import { PasswordChangeComponent } from './password/change/password-change.component';
import { ActivateComponent } from './activate/activate.component';
import { RegisterComponent } from './register/register.component';
import { SettingsComponent } from './settings/settings.component';

@NgModule({
    imports: [
        QueuingSystemSharedModule,
        RouterModule.forRoot(ACCOUNT_ROUTES),
        ServiceProviderModule,
        GenericModule
    ],
    declarations: [
        PasswordStrengthBarComponent,
        PasswordResetInitComponent,
        PasswordResetFinishComponent,
        PasswordChangeComponent,
        ActivateComponent,
        RegisterComponent,
        SettingsComponent
    ]
})
export class AccountModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/account/account.module.ts